import * as React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const reviews = [{
  text: "I'm very thankful to Dr Zanos. I came as I did not feel my leg from knee to foot. After 3 sessions I started to feel my leg and to feel good myself.",
  author: "Paivm · Google review"
}, {
  text: "I work out and hike/run quite a lot. Have received amazing care at Bodywerks. It has helped me a lot keeping my body aligned and out of trouble.",
  author: "Pablo M. · Google review"
}, {
  text: "Months of physiotherapy can't even start solving the problem of what just a session at this chiropractor can.",
  author: "C M. · Google review"
}];
export default function Kundeanmeldelser() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="16902" id="testimonials" ref={ref} className={cn("bg-background text-foreground py-24 transition-opacity duration-700", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="font-serif text-4xl md:text-5xl font-semibold mb-16 text-center text-primary tracking-tight">
          Patient Success Stories
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reviews.map((review, i) => <Card key={i} data-index={i} className="bg-card rounded-3xl border border-border shadow-md h-full transition-transform hover:scale-[1.02]">
              <CardContent className="pt-8 flex flex-col h-full justify-between">
                <p className="font-sans text-lg italic text-foreground leading-relaxed">
                  &quot;{review.text}&quot;
                </p>
                <p className="font-sans text-base font-semibold mt-6 text-primary uppercase tracking-wider">
                  — {review.author}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}